import { i18nNsFactory } from '@atlas-frontend/i18n';
import { Button, Flex } from 'antd';
import React, { useCallback, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import styled from 'styled-components';
import { ExecutionFormDataType, ExecutionPeriodFormDataType } from '../schema';
import translations from '../translations/ExecutionPeriods.translations.json';
import { PeriodEditTable } from './PeriodEditTable';
import { PeriodicityModal } from './PeriodicityModal';
import { PeriodViewTable } from './PeriodViewTable';
import { DataObjectGroupType } from '../types';
const { addTranslations, useTranslation } = i18nNsFactory('execution-periods');
addTranslations(translations);

export function ExecutionPeriodsEdit({
  groupType,
  isInput,
}: {
  groupType: DataObjectGroupType;
  isInput: boolean;
}) {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { setValue } = useFormContext();

  const showModal = useCallback(() => {
    setIsModalOpen(true);
  }, []);
  const handleCancel = useCallback(() => {
    setIsModalOpen(false);
  }, []);
  const handleOk = useCallback(
    (periods: ExecutionPeriodFormDataType[]) => {
      setIsModalOpen(false);
      setValue('execution.executionPeriods', periods, { shouldDirty: true });
    },
    [setValue]
  );

  return (
    <PeriodsTableWrapper>
      <ButtonRowWrapper justify="end" align="center" gap={12}>
        <Button id="manage-periods" type="primary" onClick={showModal}>
          {t('button.manage-periods')}
        </Button>
      </ButtonRowWrapper>
      <PeriodEditTable groupType={groupType} />
      {isModalOpen && (
        <PeriodicityModal
          onOk={handleOk}
          onCancel={handleCancel}
          isInput={isInput}
        />
      )}
    </PeriodsTableWrapper>
  );
}

export interface ExecutionPeriodsViewProps {
  groupType: DataObjectGroupType;
  loadingType?: string;
  execution: ExecutionFormDataType | null;
}

export function ExecutionPeriodsView({
  groupType,
  execution,
  loadingType,
}: ExecutionPeriodsViewProps) {
  const periods = execution?.executionPeriods ?? [];

  return (
    <PeriodsTableWrapper>
      <PeriodViewTable
        groupType={groupType}
        loadingType={loadingType}
        periods={periods}
        periodCount={execution?.periodCount ?? null}
      />
    </PeriodsTableWrapper>
  );
}

const ButtonRowWrapper = styled(Flex)`
  padding-bottom: 12px;
`;

const PeriodsTableWrapper = styled.div`
  width: 100%;
`;
